import { Field, Form, Formik } from "formik"
import { Row, Col, Label, Button, Input } from "reactstrap";
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '..';
import { CustomTextInput } from "./Fields/CustomTextInput";
import { CustomSwitch } from "./Fields/CustomSwitch";
import { CustomSelect } from "./Fields/CustomSelect";
import { CustomRadioInput } from "./Fields/CustomRadioInput";
import CustomImgUpload from "./Fields/CustomImgUpload";
import { CustomTextArea } from "./Fields/CustomTextArea";
import { CustomLabel } from "./Fields/CustomLabel";
import { getInputs } from "./getFormValues";
import { useParams } from "react-router-dom";
import { setDataAction, setMediaDataAction, updateDataAction } from "../Store/Generic/GenericSlice";
import CustomReactSelect from "./Fields/CustomReactSelect";
import { CustomHiddenInput } from "./Fields/CustomHiddenInput";
import '../global/GlobalCSS.css';
import { CustomLink } from "./Fields/CustomLink";

const GenericForm: React.FC = () => {
  const [loCode, setLoCode] = useState('')
  const [portCode, setPortCode] = useState('')
  const { masters } = useParams();
  let { inputs, validationSchema, initialValues } = getInputs(masters);
  // const [visible, setVisible] = useState(true)
  const dispatch = useDispatch();
  const { records, recordID, flags } = useSelector((state: RootState) => state.Generic);
  const record = records.find((rec: any) => rec.id === recordID) ?? initialValues;
  let [selectName] = useState<Array<string>>([])
  let [selectedValue] = useState<Array<string>>([])
  let [switchValue] = useState<Array<boolean>>([])
  let [switchName] = useState<Array<string>>([])
  const [loCodeField, setLoCodeField] = useState('')
  const [euPort, setEuPort] = useState(false)

  const handleCreateData = (masters: string, newData: any) => {
    if (masters === 'country_master') {
      dispatch(setMediaDataAction(masters, newData));
    } else {
      dispatch(setDataAction(masters, newData));
    }
  };

  const handleUpdateData = (masters: string, updatedData: any) => {
    dispatch(updateDataAction(masters, updatedData));
  };

  const handleSelect = async (e: any, Fname: any) => {
    selectName.push(Fname.name);
    selectedValue.push(e.id);
    if (Fname.name === 'country_name') {
      setLoCodeField('lo_code')
      setLoCode(`${e.country_iso_code3}${portCode}`)
      setEuPort(e?.is_this_an_eu_country)
    }
  }

  function handleCustomSelect(e: any, Fname: any) {
    selectName.push(Fname.name);
    selectedValue.push(e.value);
  }

  // function handle_Switch_Change(e: any, fname: any) {
  //   switchName.push(fname.name)
  //   switchValue.push(e.target.checked)
  //   if (e.target.name === 'does_vessel_have_a_portable_gangway') {
  //     if (e.target.checked === true) {
  //       setVisible(false)
  //     } else {
  //       setVisible(true)
  //     }
  //   }
  // }

  function handle_Textbox_Changes(e: any, fname: any) {
    if (fname.name === 'port_code')
      setPortCode(e.target.value)
  }

  return (
    <>
      <div>
        {/* JSX for displaying the data and interacting with the CRUD functions */}
        <Formik
          {...{ initialValues: record, validationSchema }}
          onSubmit={
            (formdata) => {
              // if (formdata['is_this_an_eu_country'] === true) {
              //   formdata['is_this_an_eu_country'] = 'EU'
              // } else {
              //   formdata['is_this_an_eu_country'] = 'NON-EU'
              // }
              if (masters === 'country_master') {
                formdata['image'] = flags[0][0];
              }
              if (formdata && formdata.id) {
                const updatedValue = { ...formdata }
                for (let i = 0; i < selectedValue.length; i++) {
                  updatedValue[selectName[i]] = selectedValue[i]
                }
                for (let i = 0; i < switchValue.length; i++) {
                  updatedValue[switchName[i]] = switchValue[i]
                }
                handleUpdateData(masters ?? '', updatedValue);
              } else {
                formdata[loCodeField] = loCode
                formdata['is_eu_port'] = euPort
                for (let i = 0; i < selectedValue.length; i++) {
                  formdata[selectName[i]] = selectedValue[i];
                }
                for (let i = 0; i < switchValue.length; i++) {
                  formdata[switchName[i]] = switchValue[i]
                }
                handleCreateData(masters ?? '', formdata);
              }
            }
          }
        >
          <Row className="center-justify">
            <Col lg={9}>
              <Form noValidate autoComplete="off">
                {
                  inputs.map(({ name, type, value, visibility, ...props }) => {
                    switch (type) {
                      case "dynamic-select":
                        return (<>
                          {
                            recordID === -1 ? <Field
                              key={name}
                              name={name}
                              label={props.placeholder}
                              id={props.id}
                              component={CustomReactSelect}
                              path={props.path}
                              onChange={(opt: any) => { handleSelect(opt, { name }) }}
                            /> : <Field
                              key={name}
                              name={name}
                              label={props.placeholder}
                              id={props.id}
                              component={CustomReactSelect}
                              path={props.path}
                              onChange={(opt: any) => { handleSelect(opt, { name }) }}
                              defaultValue={record[props?.defaultValueName]}
                            />
                          }
                        </>)

                      case "select":
                        return <CustomSelect
                          key={name}
                          label={props.label!}
                          name={name}
                          options={props.options}
                          className="form-control mb-3"
                          onChange={(opt: any) => handleCustomSelect(opt, { name })}
                        />

                      case "radio-group":
                        return <CustomRadioInput
                          label={props.label!}
                          name={name}
                          options={props.options!}
                          key={name}
                          className="form-control mb-3"
                        />

                      case "checkbox":
                        return (<>
                          {
                            recordID === -1 ?
                              <CustomSwitch
                                id={name}
                                label={props.label!}
                                key={name}
                                name={name}
                                on={props.on!}
                                off={props.off!}
                                value={(e: any) => e.target.checked}
                                // onChange={(e: any) => handle_Switch_Change(e, { name })}
                                class={props.class}
                              /> : name === 'is_eu_port' ?
                                <Field name={name}>
                                  {() => (
                                    <Input
                                      id={name}
                                      label={props.label!}
                                      key={name}
                                      on={props.on!}
                                      off={props.off!}
                                      defaultChecked={props?.defaultChecked}
                                      checked={euPort}
                                      // onChange={(e: any) => handle_Switch_Change(e, { name })}
                                      class={props.class}
                                    />
                                  )}
                                </Field> :
                                <CustomSwitch
                                  id={name}
                                  label={props.label!}
                                  key={name}
                                  name={name}
                                  on={props.on!}
                                  off={props.off!}
                                  value={(e: any) => e.target.checked}
                                  // onChange={(e: any) => handle_Switch_Change(e, { name })}
                                  defaultChecked={record[name]}
                                  class={props.class}
                                />
                          }
                        </>
                        )

                      case "file":
                        return (
                          <div>
                            <CustomImgUpload
                              type={type}
                              label={props.label!}
                              placeholder={props.placeholder!}
                              key={name}
                              name={name}
                              className="form-control mb-3"
                            />
                          </div>
                        )

                      case "textarea":
                        return (
                          <div className="form-floating mb-3">
                            <CustomTextArea
                              key={name}
                              name={name}
                              placeholder={props.placeholder}
                              type={type}
                              id={props.id}
                              className="form-control mb-3"
                            />
                            <Label for={name}>{props.placeholder}</Label>
                          </div>
                        )

                      case "label":
                        return (
                          <div className="mb-3">
                            <CustomLabel
                              name={name}
                              placeholder={props.placeholder}
                              type={type}
                              id={props.id}
                              className="form-control mb-3"
                            />
                          </div>
                        )

                      case "hidden":
                        return (
                          <div className="form-floating mb-3">
                            <CustomHiddenInput
                              key={name}
                              name={name}
                              placeholder={props.placeholder}
                              type={type}
                              id={props.id}
                              className="form-control mb-3"
                            />
                            <Label for={name}>{props.placeholder}</Label>
                          </div>
                        )

                      case "text-unit":
                        return (
                          <div className="form-floating input-group mb-3">
                            <CustomTextInput
                              key={name}
                              name={name}
                              placeholder={props.placeholder}
                              type={type}
                              id={props.id}
                              unit={props.unit}
                              className="form-control"
                            /><div className="input-group-text">{props.unit}</div>
                            <Label className="asteric" for={name}>{props.placeholder}</Label>
                          </div>
                        )

                      case "link":
                        return (
                          <CustomLink
                            placeholder={props.placeholder}
                            type={type}
                            id={props.id}
                            name={name}
                            className="form-control mb-3"
                            popupPath={props.popupPath}
                            popupColTitle={props.popupColTitle}
                            popupType={props.popupType}
                            popupTblField={props.popupTblField}
                            popupTblState={props.popupTblState}
                            popupTblType={props.popupTblType}
                          />
                        )

                      default:
                        return (
                          <>
                            {name === 'lo_code' ? <div className="form-floating mb-3">
                              <CustomTextInput
                                key={name}
                                name={name}
                                placeholder={props.placeholder}
                                type={type}
                                id={props.id}
                                disabled={props.disabled}
                                className="form-control mb-3"
                                value={loCode}
                              />
                              <Label for={name}>{props.placeholder}</Label>
                            </div>
                              : <div className="form-floating mb-3">
                                <CustomTextInput
                                  key={name}
                                  name={name}
                                  placeholder={props.placeholder}
                                  type={type}
                                  id={props.id}
                                  autoFocus={props.autoFocus}
                                  className="form-control mb-3"
                                  onBlur={(e: any) => handle_Textbox_Changes(e, { name })}
                                  hidden={visibility}
                                />
                                <Label className="asteric" for={name}>{props.placeholder}</Label>
                              </div>}
                          </>
                        )
                    }
                  })
                }
                <Row>
                  <div className="d-flex flex-wrap gap-5 grp_justify_right">
                    <Button type="submit" color="primary" className='btn_size4_5_cstm'>Save</Button>
                    <Button type="reset" color="danger" className='btn_size4_5_cstm'>Reset</Button>
                  </div>
                </Row>
              </Form>
            </Col>
          </Row>
        </Formik>
      </div>
    </>
  )
}
export default GenericForm;